export default function MailChimp(props){
  return (
    <div id="sign-up" className={`signup ${props.where ?? 'uni'} ${props.addClass ?? 'std'}`}>
      <link href="//cdn-images.mailchimp.com/embedcode/slim-10_7.css" rel="stylesheet" type="text/css" />
      <div id="mc_embed_signup">
        <form
          action="https://ginnylanebargrill.us10.list-manage.com/subscribe/post?u=fe0c421eb8ae1acbc885e39d3&amp;id=303b0e0335"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank" 
          noValidate
        >
          <div id="mc_embed_signup_scroll">
            <label htmlFor="mce-EMAIL">Join Our Mailing List</label>
            <input type="email" defaultValue="" name="EMAIL" className="email" id="mce-EMAIL" placeholder="Email" required />
            {/* <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--> */}
            <div style={{position:'absolute', left:'-5000px', ariaHidden:'true'}}><input type="text" name="b_fe0c421eb8ae1acbc885e39d3_303b0e0335" tabIndex="-1" defaultValue="" /></div>
            <div className="clear sub-btn"><input type="submit" value="Sign Up" name="subscribe" id="mc-embedded-subscribe" className="button" /></div>
          </div>
        </form>
      </div>
    </div>
  )
}